/* eslint-disable prettier/prettier */
  // Site Url
  export const baseURL = 'https://dokan.ajaira.website';
  
  // Dokan base endPoint
  export const dokanV1 = `${baseURL}/wp-json/dokan/v1`;
  
  // Product Api
  export const productsAPI = `${dokanV1}/products`;
  export const productsWCAPI = `${baseURL}/wp-json/wc/v3/products`;
  export const productSummaryAPI = `${productsAPI}/summary`;
  export const productAttributeAPI = `${productsAPI}/attributes`;
  
  // Order Api
  export const ordersAPI = `${dokanV1}/orders`;
  export const orderSummaryAPI = `${ordersAPI}/summary`;
  
  // Withdraw & Balance Api
  export const withdraw = `${dokanV1}/withdraw`;
  export const balance = `${withdraw}/balance`;
  export const stores = `${withdraw}/stores`;
  
// Settings Api
export const settings = `${dokanV1}/settings`;

// Review Api
// export const reviews = `${dokanV1}/reviews`;
// export const reviewSummary = `${reviews}/summary`;

// Report Api
 export const reportsAPI = `${dokanV1}/reports`;
 export const reportSummeryAPI = `${reportsAPI}/summary`;
 export const salesOverviewAPI = `${reportsAPI}/sales_overview`;
 export const topEarnersAPI = `${reportsAPI}/top_earners`;
 export const topSellingAPI = `${reportsAPI}/top_selling`;


  // Coupon Api
//   export const coupons = `${dokanV1}/coupons`;
  